export function humanizeKey(k) {
  return String(k).replace(/([A-Z])/g, " $1").replace(/[_-]+/g, " ").replace(/^./, (s) => s.toUpperCase()).trim();
}

// 12a: object-safe field formatter. Extraction JSON fields can arrive as
// string | number | boolean | string[] | object[] | object — every render
// and export (result card, Excel, PPT) routes through here so String(obj)
// ("[object Object]") is unreachable. Arrays of objects render one line per
// object with humanized keys ("Date: 2026-03-01 · Event: LOI deadline").
export function formatFieldValue(v, depth = 0) {
  if (v === null || v === undefined) return null;
  if (v === true) return "Yes";
  if (v === false) return "No";
  if (typeof v === "string" || typeof v === "number") {
    const s = String(v).trim();
    if (!s || s === "Not specified" || s === "false" || s === "[]") return null;
    return s;
  }
  if (Array.isArray(v)) {
    const parts = v.map(item => formatFieldValue(item, depth + 1)).filter(Boolean);
    return parts.length ? parts.join("\n") : null;
  }
  if (typeof v === "object") {
    if (depth >= 3) { try { return JSON.stringify(v); } catch { return null; } }
    const entries = Object.entries(v)
      .filter(([k]) => !k.startsWith("_"))
      .map(([k, val]) => {
        const f = formatFieldValue(val, depth + 1);
        return f ? `${humanizeKey(k)}: ${f.replace(/\n/g, "; ")}` : null;
      })
      .filter(Boolean);
    return entries.length ? entries.join(depth === 0 ? "\n" : " · ") : null;
  }
  return null;
}
